import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useRouteError } from 'react-router';
import { useIntl } from 'react-intl';
import NotFoundPage from './NotFoundPage';
import PermissionDeniedPage from './PermissionDeniedPage';
import { Button } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import './SystemStyles.scss';
import NotFoundPageWithOutLogin from './NotFoundPageWithOutLogin';
import { getAuthorizedData } from '../../Authorized/reducer';

export default function ErrorPage() {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const error = useRouteError();
  const { loggedIn } = useSelector(getAuthorizedData);
  if (error.status === 404) {
    return loggedIn ? <NotFoundPage /> : <NotFoundPageWithOutLogin />;
  }
  if (error.status === 403) {
    return <PermissionDeniedPage />;
  }
  return (
    <div className="not-found-page-wrapper">
      <div className="login-background" />
      <div className="not-found-page">
        <div className="not-found-block-wrapper">
          <div className="not-found-block-border">
            <div className="not-found-block">
              <h1>{formatMessage({ id: 'errors.page.title' })}</h1>
              <p>{formatMessage({ id: 'errors.page.message' })}</p>
              <p>
                <i>{error.statusText || error.message}</i>
              </p>
              <div className="text-3">
                <Button
                  className="big"
                  onClick={() => {
                    navigate(window.baseRoute || '/');
                  }}
                >
                  {formatMessage({ id: 'back.to.main' })}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
